import { ParserFunctionType } from "../parser.type";
import { ParserAbstraction } from "@bitwarden/web-vault/app/services/dali/vault-parser/parser/parser.abstraction";
import { SyncStatusStoreModel } from "../../../../models/store/sync-status.store.model";
import { sync_status_v1_to_v2 } from "@bitwarden/web-vault/app/services/dali/vault-parser/model-dto/sync-status";

export class SyncStatusParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Sync status parser version ${version}`);
    }

    if (version === 1) {
      return SyncStatusParser_v1;
    }

    return SyncStatusParser_v2;
  }

  override getSupportedVersion(): number[] {
    return [1, 2];
  }
}

const SyncStatusParser_v2 = (vaultItem: any): SyncStatusStoreModel =>
  vaultItem as SyncStatusStoreModel;

const SyncStatusParser_v1 = (syncStatus: any): SyncStatusStoreModel => {
  const upgraded = sync_status_v1_to_v2(syncStatus);
  /** We need to remap the vid properties as this is new and was not map in the previous blobby type **/
  upgraded.vid = syncStatus.vid ?? "";
  return SyncStatusParser_v2(upgraded);
};
